import { Text } from "@ds/react";
import styled from "styled-components/macro";

export const StyledTitle = styled.div(({ theme, isMarginTop }) => ({
  p: {
    fontSize: "14px",
    color: theme.color.neutral["02"],
    lineHeight: "20px",
    margin: "0",
    fontWeight: "500",
    marginTop: isMarginTop ? "30px" : 0,
    "&.isMarginRight": {
      marginRight: "10px",
    },
    "&.small": {
      fontSize: "12px",
      fontWeight: "700",
      lineHeight: "21px",
      marginBottom: "5px",
      marginTop: "5px",
    },
    "&.bold": {
      fontSize: "16px",
      fontWeight: "700",
      lineHeight: "24px",
    },
    [theme.breakpoint.lg()]: {
      fontSize: "16px",
      "&.small": {
        fontSize: "14px",
      },
    },
  },
}));

export const ContentTituloInfoContainer = styled(StyledTitle)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginTop: "20px",
  [theme.breakpoint.lg()]: {
    marginTop: "0",
  },
}));

export const WrapperContentSorteio = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  width: "100%",
}));

export const ContentTooltip = styled.div(() => ({
  display: "flex",
  alignItems: "center",
}));

export const ContainerTooltip = styled.button(() => ({
  display: "flex",
  alignItems: "center",
  outline: "none",
  border: "none",
  cursor: "pointer",
  backgroundColor: "#FFFF",
}));

export const PrizeText = styled(Text)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "400",
  textAlign: "right",
  color: theme.color.neutral["02"],
  lineHeight: "24px",

  [theme.breakpoint.lg()]: {
    lineHeight: "27px",
    fontSize: "16px",
  },
}));

export const PrizeContainer = styled(StyledTitle)(() => ({
  flexDirection: "column",
  display: "flex",
  width: "100%",
  alignItems: "flex-end",
}));

export const ContentNextStep = styled.div(() => ({
  flexDirection: "column",
  display: "flex",
  width: "100%",
  alignItems: "flex-start",
  justifyContent: "center",
  marginTop: 25,
}));

export const WrapperContentButton = styled.div(() => ({
  marginBottom: 20,
}));
